import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const UnderConstructionStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
  pt: { sm: '450' },
  pb: { sm: '700' },
  mb: { sm: '800' },
})`
  ${({ theme }) => css`
    border-radius: ${theme.radii[900]};
    background-color: ${theme.colors.blue[100]};
    overflow: hidden;
    width: 217px;
    height: 216px;
  `}
`;
